// extracted by mini-css-extract-plugin
export default {"main":"cardContainer_main__s-Z+f","container":"cardContainer_container__S6b-o"};